(() => {
const $ce31f963f53be0bc$var$footerTemplate = `
    <footer class="gov-container u-bg-color--grey-dark gov-footer">
    <div class="gov-container__content">
        <section class="gov-footer__upper u-screen--only" data-slot="footer-column-content">
        </section>
        <hr>
        <section class="gov-footer__lower">
            <p class="gov-footnote copyright-content">
                2023 \xa9 Ministerstvo spravedlnosti            </p>
            <p class="gov-footnote version-content">
                Verze 1.0.0            </p>
        </section>
        <button class="gov-button gov-button--primary-outlined gov-button--inversed gov-footer__scroll-up gov-js--scroll-up" aria-labelledby="fo-scrollBtn">
          <span id="fo-scrollBtn" class="u-sr-only gov-button__label">Zp\u{11B}t nahoru</span>
        </button>
    </div>
</footer>
`;
/* ====== <eisir-footer-column> ====== */ class $ce31f963f53be0bc$var$EisirFooterColumn extends HTMLElement {
    constructor(){
        super();
    }
    // zmrazené odkazy původního obsahu (nikdy nepřesouvat), plní se při prvním connectu
    links = [];
    getHeader() {
        return this.closest('body')?.querySelector?.('eisir-header') || document.querySelector('eisir-header') || null;
    }
    setupLinks() {
        const header = this.getHeader();
        const lang = header ? header.getAttribute('selectedlang') : 'cs';
        const ul = this.querySelector('.gov-list--plain');
        if (!ul) return;
        ul.textContent = '';
        const frag = document.createDocumentFragment();
        for (const link of this.links){
            const dataLang = link.getAttribute('data-lang');
            if (dataLang && dataLang !== lang) continue;
            const li = document.createElement('li');
            li.appendChild(link.cloneNode(true)); // KLON, nikdy nepřesouvat originál
            frag.appendChild(li);
        }
        ul.appendChild(frag);
    }
    _onLangChange = null;
    connectedCallback() {
        this.className = 'gov-footer__col';
        const title = this.getAttribute('title') || '';
        // zmrazit původní <a> před přepisem innerHTML
        if (!this.links || this.links.length === 0) //debugger;
        this.links = Array.from(this.querySelectorAll('a'));
        // přepiš markup (výstupní UL se bude plnit klony)
        this.innerHTML = `
      <style>
        eisir-footer-column a[target="_blank"]:after { line-height: 0; }
      </style>
      <h5 class="gov-footer__headline">${title}</h5>
      <ul class="gov-list--plain"></ul>
    `;
        // jazyk – posloucháme globálně (nezávislé na konkret. instanci headeru)
        if (!this._onLangChange) {
            this._onLangChange = ()=>this.setupLinks();
            document.addEventListener('lang-changed', this._onLangChange, true);
        }
        this.setupLinks();
    }
    disconnectedCallback() {
        if (this._onLangChange) document.removeEventListener('lang-changed', this._onLangChange, true);
        // necháme _onLangChange nulovat, aby se při dalším connectu zaregistroval jen jednou
        this._onLangChange = null;
    }
}
/* ====== <eisir-footer> ====== */ class $ce31f963f53be0bc$var$EisirFooter extends HTMLElement {
    static get observedAttributes() {
        return [
            'ready',
            'copyright',
            'version'
        ];
    }
    // stav uložený mimo render
    _initialized = false;
    _srcColumns = [];
    constructor(){
        super();
    }
    connectedCallback() {
        const ready = this.getAttribute("ready");
        this.style.opacity = ready !== "false" ? '1' : '0';
        // poprvé si vezmeme zdrojové sloupce (ještě před přepisem DOM)
        if (!this._initialized) this._initialized = true;
        // render po malé prodlevě (pokud spoléháš na postupný mount okolí)
        setTimeout(()=>{
            this._srcColumns = Array.from(this.querySelectorAll('eisir-footer-column'));
            this.innerHTML = '';
            this._render();
            this._updateCopyright();
            this._updateVersion();
            this._ready();
        }, 10);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (name === 'ready' && newValue === "true") this.style.opacity = '1';
        if (name === 'copyright') this._updateCopyright();
        if (name === 'version') this._updateVersion();
    }
    _render() {
        this.innerHTML = $ce31f963f53be0bc$var$footerTemplate;
        const holder = this.querySelector('[data-slot="footer-column-content"]');
        if (!holder) return;
        // 2) vlož KLONY sloupců (originály necháme být)
        const frag = document.createDocumentFragment();
        for (const col of this._srcColumns){
            const clone = col.cloneNode(true);
            clone.style.opacity = '1';
            frag.appendChild(clone);
        }
        holder.appendChild(frag);
    }
    _updateCopyright() {
        const title = this.getAttribute("copyright") || "2023 \xa9 Ministerstvo spravedlnosti";
        const el = this.querySelector(".copyright-content");
        if (el) el.textContent = title;
    }
    _updateVersion() {
        const title = this.getAttribute("version") || "Verze 1.0.0";
        const el = this.querySelector(".version-content");
        if (el) el.textContent = title;
    }
    _ready() {
        const event = new CustomEvent('ready', {
            detail: true,
            bubbles: true,
            cancelable: true
        });
        this.dispatchEvent(event);
    }
}
customElements.define("eisir-footer", $ce31f963f53be0bc$var$EisirFooter);
customElements.define("eisir-footer-column", $ce31f963f53be0bc$var$EisirFooterColumn);

})();
//# sourceMappingURL=eisir-footer.js.map
